import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalController, NavController, NavParams, Platform } from '@ionic/angular';

@Component({
  selector: 'symphony-solo-wallet-interrogate-success-page',
  templateUrl: './wallet-interrogate-success-page.component.html',
  styleUrls: ['./wallet-interrogate-success-page.component.scss'],
  providers: [NavParams],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WalletInterrogateSuccessPageComponent implements OnInit {
  public topup = this.navParams.get('topup');
  public generalData = this.navParams.get('generalData');
  public modalOptions = {
    header: null,
    message: null,
    display: null
  }
  public currencySymbol = '£';
  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public platform: Platform,
    private navParams: NavParams,
    private cdf: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    if(this.topup) {
      this.topup = (+this.topup).toFixed(2);
      this.modalOptions.header = 'Top Up Successful';
      this.modalOptions.message = `${this.currencySymbol}  ${(+this.topup).toFixed(2)} has been added to your account`;
    }else if(this.generalData) {
      this.modalOptions.header = this.generalData?.header;
      this.modalOptions.message = this.generalData?.message;
    }
    this.cdf.detectChanges();
  }

  // convenience getter for easy access to form fields
  
  public dismissModal() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }
  
}
